import './CTA.css';

function CTA() {
    return (
        <section className="cta">
            <div className="container">
                <div
                    className="cta-wrap spacing"
                >
                    <div className="cta-text-wrap">
                        <h1 className="h2 features-01-heading">
                            Ready to Transform Your Web Scraping Workflow?
                        </h1>
                    </div>
                    <div className="cta-btn-wrap">
                        <a href="/contact-us" className="button-1 w-inline-block">
                            <div className="button-1-text">Sign Up</div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CTA;